import { Module, VuexModule, Action, Mutation, getModule } from 'vuex-module-decorators'
import store from '@/store'
import { Catalogo } from '@/types/types'
import { CatalogoService } from '@/services/CatalogoService'
@Module({
  namespaced: true,
  name: 'catalogos',
  store,
  dynamic: true
})
class CatalogoModule extends VuexModule {
  items: Catalogo[] = []
  service = new CatalogoService()

  @Action({ commit: 'setItems' })
  async fetchAll () {
    const catalogos = await this.service.fectchAllRequest()
    return catalogos.data.data
  }

  @Mutation
  setItems (items: Catalogo[]) {
    this.items = items
  }
}

export default getModule(CatalogoModule)
